<template>
  <div class="bar-4">
    <div class="news">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        class="card"
        :class="`card-${index + 1}`"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <div class="card__img">
          <ImageContainer
            class="img"
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
          />
        </div>
        <div class="card__content">
          <div class="opacity-content"></div>
          <div class="card__category">
            <div>{{ item.sub_category.name }}</div>
          </div>
          <div class="card__title">
            <h3 class="title limited-text">
              {{ item.title }}
            </h3>
            <p class="card__brief limited-text">{{ item.brief }}</p>
          </div>
          <div class="data-news">
            <span class="day">{{ handleDate(item.pub_date) }}, </span>
            <span class="time">{{ handleTime(item.pub_date) }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.bar-4 {
  width: 100%;
  margin-bottom: 7rem;
}
.news {
  padding-top: 6rem;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(4, auto);
  .card {
    grid-column: span 1;
  }
  .card-1,
  .card-2 {
    padding: 0 10%;
    grid-column: 1 / span 1;
    position: relative;
    .card__img {
      width: 15vw;
      min-width: 294px;
      position: relative;
      z-index: 0;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(18, 18, 18, 0.45);
        z-index: 1;
      }
      .img {
        padding-bottom: 66%;
      }
    }
    .card__content {
      padding: 0 2em 3em;
      position: relative;
      z-index: 1;
      width: 80%;
      margin-left: 20%;
      transform: translateY(-50%);
      &:hover {
        &::before {
          background: linear-gradient(
            180deg,
            #3a4074 0%,
            rgba(59, 65, 117, 0.991353) 12.56%,
            rgba(62, 67, 118, 0.96449) 25.13%,
            rgba(67, 71, 121, 0.91834) 37.69%,
            rgba(75, 77, 125, 0.852589) 50.26%,
            rgba(84, 84, 130, 0.768225) 62.82%,
            rgba(96, 92, 136, 0.668116) 75.39%,
            rgba(108, 102, 143, 0.557309) 87.95%,
            rgba(122, 111, 150, 0.442691) 100.52%,
            rgba(134, 121, 157, 0.331884) 113.08%,
            rgba(146, 129, 163, 0.231775) 125.65%,
            rgba(155, 136, 168, 0.147411) 138.21%,
            rgba(163, 142, 172, 0.0816599) 150.78%,
            rgba(168, 146, 175, 0.03551) 163.34%,
            rgba(171, 148, 176, 0.0086472) 175.9%,
            rgba(172, 149, 177, 0) 188.47%
          );
        }
      }
      transition: all 0.4s;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: all 0.4s;

        background: linear-gradient(
          180deg,
          #3a4074 0%,
          rgba(59, 65, 117, 0.991353) 6.67%,
          rgba(62, 67, 118, 0.96449) 13.33%,
          rgba(67, 71, 121, 0.91834) 20%,
          rgba(75, 77, 125, 0.852589) 26.67%,
          rgba(84, 84, 130, 0.768225) 33.33%,
          rgba(96, 92, 136, 0.668116) 40%,
          rgba(108, 102, 143, 0.557309) 46.67%,
          rgba(122, 111, 150, 0.442691) 53.33%,
          rgba(134, 121, 157, 0.331884) 60%,
          rgba(146, 129, 163, 0.231775) 66.67%,
          rgba(155, 136, 168, 0.147411) 73.33%,
          rgba(163, 142, 172, 0.0816599) 80%,
          rgba(168, 146, 175, 0.03551) 86.67%,
          rgba(171, 148, 176, 0.0086472) 93.33%,
          rgba(172, 149, 177, 0) 100%
        );
        opacity: 0.7;
        z-index: -1;
      }
      .title {
        font-size: 1.1em;
        font-weight: 600;
      }
    }
    .card__title .title,
    .card__category {
      --snup: 2;
      transform: translateX(-20%);
      width: 130%;
    }
    .data-news {
      text-align: right;
    }
  }
  .card-2 {
    grid-column: 2 / span 1;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 40%;
      left: 0;
      right: auto;
      bottom: auto;
      width: 1px;
      height: 50%;
      transform: translateY(-50%);
      background: linear-gradient(
        180deg,
        rgba(151, 134, 166, 0) 0%,
        #9786a6 51.52%,
        rgba(151, 134, 166, 0) 100%
      );
    }
  }
  .card-3,
  .card-4,
  .card-5 {
    grid-column: 1 / span 1;
    position: relative;
    z-index: 1;
    width: 90%;
    .card__content {
      margin-left: 25%;
      padding: 2rem 4rem 2rem 0;
      border-bottom: 1px solid #ac95b1;
    }
    .card__brief {
      display: none;
    }
    .data-news {
      text-align: right;
      padding-right: 4rem;
    }
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(90deg, #3a4074 0%, #ac95b1 100%);
      opacity: 0.7;
      z-index: -1;
    }
  }
  .card-5 {
    .card__content {
      border-bottom: none;
    }
  }
  .card-6 {
    grid-row: 2 / span 3;
    grid-column: 2;
    padding: 3rem 5rem 3rem 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    .card__img {
      flex: 1 0 49%;
      width: 100%;
      // height: 50%;
      margin-top: 2rem;
      .img {
        padding-bottom: 70%;
      }
    }
    .card__content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      height: 80%;
    }
    .card__brief {
      margin-top: 2rem;
      --snup: 6;
    }
    .data-news {
      text-align: right;
    }
  }
}
@media screen and (max-width: 1500px) {
  .bar-4 {
    margin-bottom: 2rem;
  }
  .news {
    grid-template-rows: 350px repeat(3, auto);
    .card-6 {
      padding: 0rem 2rem 0rem 1rem;
      .card__img {
        margin-top: 0;
        .img {
          padding-bottom: 80%;
        }
      }
    }
    .card-3,
    .card-4,
    .card-5 {
      .card__content {
        padding: 1rem 4rem 1rem 0;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .bar-4 {
    padding-top: 5rem;
    margin-bottom: 2rem;
  }
  .news {
    padding: 0;
    .card-6 {
      // grid-row: 3 / span 3;
      grid-column: 2;
      padding: 1rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
      .card__img {
        flex: 1;
        width: 100%;
        margin-top: 0rem;
        .img {
          // height: 224px;

          padding-bottom: 60%;
        }
      }
      .card__content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 80%;
        .card__title {
          .card__brief {
            margin-top: 1rem;
            --snup: 6;
          }
        }
      }
      .data-news {
        text-align: right;
      }
    }
    .card-3,
    .card-4,
    .card-5 {
      grid-column: 1 / span 1;
      position: relative;
      z-index: 1;
      width: 100%;
      .card__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        margin-left: 1em;
        padding: 0;
        padding-right: 1rem;
        border-bottom: 1px solid #ac95b1;
      }
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(90deg, #3a4074 0%, #ac95b1 100%);
        opacity: 0.7;
        z-index: -1;
      }
      .data-news {
        padding-right: 1rem;
      }
    }
    .card-1,
    .card-2 {
      padding: 0;
      grid-column: span 2;
      width: 95%;
      margin: 0 auto;
      transform: translateY(15%);
      .card__content {
        width: 80%;
      }
    }
    .card-2 {
      grid-row: 5;
      &::before {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .bar-4 {
    padding-top: 3rem;
  }
  .news {
    grid-template-rows: auto;
    .card-1,
    .card-2 {
      .card__content {
        padding: 0rem 1rem;
      }
      .card__title .title {
        font-size: 15px !important;
        transform: translateX(0%);
        width: 100%;
        --snup: 3;
      }
      .card__category {
        transform: translateX(0%);
      }
      .card__brief {
        display: none;
      }
      .card__img {
        width: 40%;
        min-width: 165px;
      }
    }
    .card-2 {
      grid-row: 10;
    }
    .card-3,
    .card-4,
    .card-5 {
      grid-column: 1 / span 2;
    }
    .card-6 {
      grid-column: 1 / span 2;
      position: relative;
      z-index: 1;
      width: 100%;
      .card__img {
        display: none;
      }
      .card__brief {
        display: none;
      }
      .card__content {
        display: block;
        width: 100%;
        height: 100%;
        margin-left: 1em;
        padding: 0;
        padding-right: 1rem;
        border-bottom: 1px solid #ac95b1;
      }
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(90deg, #3a4074 0%, #ac95b1 100%);
        opacity: 0.7;
        z-index: -1;
      }
      .data-news {
        padding-right: 1rem;
      }
    }
  }
}
</style>
